import { ModalAction, ModalActionTypes } from '@acorns/web-components'

import { domainMap } from 'config/env'

import getDefaultEventData from 'components/Trackers/defaults'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import trackEvent from 'utils/analytics/trackEvent'

export const generateErrorCodeMap = ({ env, ...props }, values) => {
  const map = new Map()

  map.set('email_has_already_been_taken', {
    title: props.title ?? 'Your account already exists',
    message:
      props.message ??
      'Looks like an account with this email address already exists. Tap below to log in.',
    actions: [
      {
        type: ModalActionTypes.secondary,
        label: props.secondaryCtaLabel ?? 'Go Back',
        handler: props.closeErrorModal,
      },
      {
        type: ModalActionTypes.primary,
        label: props.primaryCtaLabel ?? 'Log in',
        handler: () => {
          trackEvent('Button Tapped', {
            eventData: {
              object_name: TRACKER_IDS.SIGNUP.EMAIL_EXISTS_REDIRECT_BUTTON,
              screen: 'registrationCreateAccount',
              screen_name: 'registrationCreateAccount',
              cta_title: 'Login',
              ...getDefaultEventData('Button Tapped'),
            },
            flow: props.flow,
          })

          const email = values?.email
          document.cookie = `emailToPrefill=${email}; domain=${domainMap.get(
            env.get('buildEnv'),
          )};max-age=3600`
          window.location.replace(env.get('loginUrl'))
        },
      },
    ],
  })

  return map
}

export const errorModal = ({
  title,
  message,
  actions,
  errorCode,
  image,
}: {
  title: string
  message: string
  actions: ModalAction[]
  errorCode: string
  image?: string
}) => {
  trackEvent('Container Viewed', {
    eventData: {
      object_name: 'registration.error',
      type: 'container_viewed',
      event_text: 'Container Viewed',
      screen: 'signupError',
      error: errorCode,
    },
  })

  if (image) {
    return {
      title,
      message,
      actions,
      image,
    }
  }

  return {
    title,
    message,
    actions,
  }
}
